export const useGetStocksQueryArg = ({ materialDocIds }: { materialDocIds: string[] }) => {
    return {
        filters: {
            material: {
                documentId: { $in: materialDocIds },
            },
        },
        populate: {
            stock_reserves: {
                populate: {
                    shipment: true,
                },
            },
        },
    }
}
